import { BonusByProductTableTranslations } from "./bonus-by-product-table-pt-br";

export const BONUS_BY_PRODUCT_TABLE_FR_FR: BonusByProductTableTranslations = {
	title: "Bonus par produit",
	filename: "bonus_par_produit",
	columns: {
		product: "Produit",
		productCategory: "Catégorie du produit",
		bonusCategory: "Catégorie du bonus",
		value: "Bonus reçu pendant la période",
		bonusSpentFromOtherPeriod: "Bonus reçu à une autre période",
		receivedInPeriod: "Reçu pendant l'événement",
		receivedInOtherPeriod: "Reçu à d'autres événements",
		total: "Total de la catégorie",
		noCategory: "Aucune catégorie",
	},
	exportToExcel: "Exporter en Excel",
};
